
import { Component, Vue } from "vue-property-decorator";
import NavBar from "./Config/header.vue";
import Choice from "./Config/choice.vue";
import VanTabs from "./Config/vanTabs.vue";
import Footer from "./Config/footer.vue";
import priceModal from "../My/shelves/priceModal.vue";
import { Dialog } from "vant";
import {
  commodityDetail,
  commodityCollect,
  commodityCancelCollect,
} from "@/req/homeIndex";
import { place } from "@/req/order";
@Component({
  components: {
    NavBar,
    Choice,
    VanTabs,
    priceModal,
    Footer,
  },
})
export default class Particulars extends Vue {
  public obj: any = {};
  public data: any = [];
  public id: any = "";
  public footerStatus = true;
  public created() {
    this.id = this.$route.query.id;
    this.detailList();
  }

  public beforeCreate() {
    const type: any = this.$route.query.type;
    if (type == 2) {
      (document as any)
        .querySelector("body")
        .setAttribute("style", "background-color:#f5f5f5");
    }
  }
  public destroyed() {
    if (this.obj.type == 2) {
      document.body.removeAttribute("style");
    }
  }
  public async detailList() {
    const res = await commodityDetail({
      commodity_id: this.id,
    });
    if (res.code === 200) {
      this.obj = res.data.commodity;
      this.data = res.data.commodity_image_detail;
    }
  }
  public async collectChange() {
    const obj = {
      commodity_id: this.id,
      serverid: this.obj.server_id,
    };
    let res;
    if (!this.obj.is_collected) {
      res = await commodityCollect(obj);
    } else {
      res = await commodityCancelCollect(obj);
    }
    if (res.code === 200) {
      this.obj.is_collected = !this.obj.is_collected;
      this.$toast(
        `${this.obj.is_collected == true ? "收藏成功" : "取消收藏成功"}`
      );
    }
  }
  public submit() {
    if (this.obj.type == 2) {
      this.$router.push({
        path: "/confirmOrder",
        query: { obj: JSON.stringify(this.obj) },
      });
    } else {
      this.getStatus();
    }
  }
  public async getStatus() {
    const obj: any = {
      commodity_id: this.obj.id,
      account: this.$store.state.user.info.account,
      role_id: "",
      server_id: this.obj.server_id,
    };
    const res = await place(obj);
    if (res.code === 200) {
      this.$router.push({
        path: "/confirmOrder",
        query: { obj: JSON.stringify(this.obj), orderId: res.data.order_id },
      });
    } else {
      Dialog.alert({
        message: res.msg,
        confirmButtonColor: "#323233",
      }).then(() => {
        // on close
      });
    }
  }
  public showPopup(item) {
    const $priceModal: any = this.$refs.priceModal;
    $priceModal.show(item);
  }
}
